module.exports = __webpack_public_path__ + "pro_commission-20bc4fb6bc7429af0e034e24311b5e49.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/pro_commission.png
// module id = 1134
// module chunks = 0 1 2 3 4